<template>
  <div class="fixed inset-0 z-30 flex flex-col items-center bg-[#0a0f18] font-sans overflow-hidden">
    <canvas ref="canvasRef" class="absolute inset-0 z-0"></canvas>
    
    <div class="relative z-10 w-full max-w-md bg-white min-h-screen flex flex-col shadow-2xl overflow-y-auto">
      
      <header class="bg-[#1e2532] text-white p-4 shadow-md flex items-center sticky top-0 z-10">
        <button @click="$router.push('/')" class="mr-4 text-white hover:text-gray-300">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path></svg>
        </button>
        <h1 class="text-lg font-bold">패키지 구매 신청</h1>
      </header>

      <main class="p-6 flex-1">
        <div class="mb-6">
          <h2 class="text-xl font-extrabold text-gray-800 mb-2">원하시는 패키지를<br/>선택해 주세요.</h2>
          <p class="text-xs text-gray-500">선택하신 패키지는 관리자 입금 확인 후 최종 승인되며, 승인 즉시 PV 및 보너스가 전산에 반영됩니다.</p>
        </div>

        <form @submit.prevent="openModal" class="space-y-4">
          
          <div class="space-y-3">
            <label v-for="pkg in packages" :key="pkg.level" class="flex items-center p-4 border rounded-xl cursor-pointer transition-all" :class="selectedPackage === pkg.level ? 'border-blue-600 bg-blue-50 shadow-md' : 'border-gray-200 hover:bg-gray-50'">
              <input type="radio" v-model="selectedPackage" :value="pkg.level" class="hidden" />
              <div class="w-5 h-5 rounded-full border-2 mr-4 flex items-center justify-center" :class="selectedPackage === pkg.level ? 'border-blue-600' : 'border-gray-300'">
                <div v-if="selectedPackage === pkg.level" class="w-2.5 h-2.5 bg-blue-600 rounded-full"></div>
              </div>
              <div class="flex-1">
                <div class="flex justify-between items-center mb-1">
                  <span class="font-extrabold text-gray-800">{{ pkg.level }} 패키지</span>
                  <div>
                    <span class="text-xs font-bold text-blue-600 bg-blue-100 px-2 py-0.5 rounded">{{ formatNumber(pkg.pv) }} PV</span>
                    <span class="text-xs font-bold text-yellow-700 bg-yellow-100 px-2 py-0.5 rounded ml-1">+{{ formatNumber(pkg.point) }} P</span>
                  </div>
                </div>
                <p class="text-sm font-semibold text-gray-600">구매가: {{ formatNumber(pkg.price) }} 원</p>
              </div>
            </label>
          </div>

          <button type="submit" :disabled="!selectedPackage" class="w-full bg-[#1e2532] text-white font-bold py-3.5 rounded-xl hover:bg-black transition-colors shadow-lg mt-6 disabled:opacity-50">
            구매 신청하기
          </button>

        </form>
      </main>

      <div v-if="showModal" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 px-4">
        <div class="bg-white rounded-2xl w-full max-w-sm overflow-hidden shadow-2xl">
          <div class="p-6 text-center">
            <h3 class="text-xl font-extrabold text-gray-800 mb-5">입금 계좌 안내</h3>

            <div class="bg-[#f8f9fa] rounded-xl p-5 border border-gray-100 shadow-inner">
              <p class="text-gray-700 font-semibold mb-4 text-base">선택 패키지: {{ selectedPackageData?.level }} 패키지</p>

              <div class="flex items-center justify-center space-x-4 mb-5">
                <span class="text-gray-700 font-bold text-sm">구매 수량</span>
                <div class="flex items-center border border-gray-300 rounded-lg bg-white overflow-hidden shadow-sm">
                  <button type="button" @click="decreaseQty" class="w-10 h-10 text-gray-600 hover:bg-gray-100 font-bold text-lg focus:outline-none">-</button>
                  <span class="w-12 text-center font-bold text-gray-800 text-lg">{{ quantity }}</span>
                  <button type="button" @click="increaseQty" class="w-10 h-10 text-gray-600 hover:bg-gray-100 font-bold text-lg focus:outline-none">+</button>
                </div>
              </div>

              <div class="mb-5">
                <p class="text-gray-800 font-bold text-base mb-1">
                  총 결제 금액: <span class="text-blue-600 text-xl">{{ formatNumber(totalPrice) }}원</span>
                </p>
                <p class="text-sm text-gray-500 font-medium">(총 적립 PV: {{ formatNumber(totalPV) }} PV)</p>
              </div>

              <hr class="border-dashed border-gray-300 mb-5" />

              <div class="mb-2">
                <p class="text-blue-800 font-extrabold text-sm mb-2">기업은행</p>
                <p class="text-2xl font-black text-gray-900 tracking-wider mb-2">17809316701017</p>
                <p class="text-gray-600 font-bold text-sm">예금주: 김용덕</p>
              </div>
            </div>

            <p class="text-red-500 text-xs mt-5 mb-6 font-semibold">
              * 위 계좌로 입금하신 후 아래 '신청하기' 버튼을 눌러주세요.
            </p>

            <div class="flex space-x-3">
              <button type="button" @click="closeModal" :disabled="isLoading" class="flex-1 bg-gray-200 text-gray-700 font-bold py-3.5 rounded-xl hover:bg-gray-300 transition-colors disabled:opacity-50">
                취소
              </button>
              <button type="button" @click="confirmPurchase" :disabled="isLoading" class="flex-1 bg-blue-500 text-white font-bold py-3.5 rounded-xl hover:bg-blue-600 shadow-md transition-colors disabled:opacity-50">
                {{ isLoading ? '처리중...' : '신청하기' }}
              </button>
            </div>
          </div>
        </div>
      </div>
      </div>
  </div>
</template>

<script>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { auth, db } from '../../firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import router from '../../router';

export default {
  name: 'PackagePurchase',
  setup() {
    const selectedPackage = ref('');
    const showModal = ref(false);
    const quantity = ref(1);
    const isLoading = ref(false);

    // 배경 캔버스 관련
    const canvasRef = ref(null);
    let ctx = null; 
    let animationFrameId = null; 
    const particles = []; 
    const particleCount = 60;

    const packages = [
      { level: '1L', price: 250000, pv: 200000, point: 50000 },
      { level: '2L', price: 750000, pv: 600000, point: 150000 },
      { level: '3L', price: 1300000, pv: 1000000, point: 250000 },
      { level: '4L', price: 3900000, pv: 3000000, point: 750000 },
      { level: '5L', price: 7800000, pv: 6000000, point: 1500000 },
      { level: 'VIP', price: 13000000, pv: 10000000, point: 2500000 }
    ];

    const selectedPackageData = computed(() => packages.find(p => p.level === selectedPackage.value) || null);
    const totalPrice = computed(() => selectedPackageData.value ? selectedPackageData.value.price * quantity.value : 0);
    const totalPV = computed(() => selectedPackageData.value ? selectedPackageData.value.pv * quantity.value : 0);

    const formatNumber = (num) => new Intl.NumberFormat('ko-KR').format(num);

    const openModal = () => {
      if (!selectedPackage.value) { alert('패키지를 선택해주세요.'); return; }
      quantity.value = 1; showModal.value = true;
    };
    const closeModal = () => { showModal.value = false; };
    const increaseQty = () => { quantity.value++; };
    const decreaseQty = () => { if (quantity.value > 1) quantity.value--; };

    const confirmPurchase = async () => {
      const user = auth.currentUser;
      if (!user) { alert('로그인이 필요합니다.'); return; }
      isLoading.value = true;
      try {
        await addDoc(collection(db, 'purchase_requests'), {
          uid: user.uid, email: user.email, level: selectedPackageData.value.level,
          unitPrice: selectedPackageData.value.price, unitPv: selectedPackageData.value.pv,
          quantity: quantity.value, totalPrice: totalPrice.value, totalPv: totalPV.value,
          status: 'PENDING', createdAt: serverTimestamp()
        });
        alert('패키지 구매 신청이 완료되었습니다.\n관리자 입금 확인 후 승인 처리됩니다.');
        showModal.value = false; router.push('/');
      } catch (error) {
        alert('신청 중 오류가 발생했습니다. 다시 시도해주세요.');
      } finally {
        isLoading.value = false;
      }
    };

    const initCanvas = () => {
      if (!canvasRef.value) return; 
      ctx = canvasRef.value.getContext('2d'); 
      resizeCanvas(); 
      window.addEventListener('resize', resizeCanvas);
      for (let i = 0; i < particleCount; i++) { 
        particles.push({ x: Math.random() * canvasRef.value.width, y: Math.random() * canvasRef.value.height, vx: (Math.random() - 0.5) * 0.4, vy: (Math.random() - 0.5) * 0.4, radius: Math.random() * 1.2 + 0.5 }); 
      }
      animate();
    };
    const resizeCanvas = () => { if (!canvasRef.value) return; canvasRef.value.width = window.innerWidth; canvasRef.value.height = window.innerHeight; };
    const animate = () => {
      if (!canvasRef.value || !ctx) return; 
      ctx.clearRect(0, 0, canvasRef.value.width, canvasRef.value.height);
      for (let i = 0; i < particles.length; i++) {
        let p = particles[i]; p.x += p.vx; p.y += p.vy; 
        if (p.x < 0 || p.x > canvasRef.value.width) p.vx *= -1; 
        if (p.y < 0 || p.y > canvasRef.value.height) p.vy *= -1;
        ctx.beginPath(); ctx.arc(p.x, p.y, p.radius, 0, Math.PI * 2); 
        ctx.fillStyle = 'rgba(255, 204, 0, 0.4)'; ctx.fill();
        for (let j = i + 1; j < particles.length; j++) { 
          let p2 = particles[j]; let dx = p.x - p2.x; let dy = p.y - p2.y; let dist = Math.sqrt(dx * dx + dy * dy); 
          if (dist < 100) { ctx.beginPath(); ctx.moveTo(p.x, p.y); ctx.lineTo(p2.x, p2.y); ctx.strokeStyle = `rgba(255, 204, 0, ${0.8 - dist / 100})`; ctx.lineWidth = 0.5; ctx.stroke(); } 
        }
      } 
      animationFrameId = requestAnimationFrame(animate);
    };

    onMounted(() => { initCanvas(); });
    onBeforeUnmount(() => { window.removeEventListener('resize', resizeCanvas); if (animationFrameId) cancelAnimationFrame(animationFrameId); });

    return { 
      packages, selectedPackage, selectedPackageData, showModal, quantity, totalPrice, totalPV, isLoading,
      formatNumber, openModal, closeModal, increaseQty, decreaseQty, confirmPurchase, canvasRef
    };
  }
}
</script>